import script from "./AddressDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddressDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AddressDialog.vue?vue&type=style&index=0&id=ef012056&lang=scss"
import "./AddressDialog.vue?vue&type=style&index=1&id=ef012056&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef012056"]])

export default __exports__